import {
  ThermometerIcon,
  RulerIcon,
  WeightIcon,
  HeartbeatIcon,
  MicroscopeIcon,
  VialIcon,
  BloodIcon,
} from '@/icons'

export const ICON_MAP = {
  Temperature: ThermometerIcon,
  Height: RulerIcon,
  Weight: WeightIcon,
  Pulse: HeartbeatIcon,
  Protein: MicroscopeIcon,
  Cholesterol: VialIcon,
  Hemoglobin: BloodIcon,
}

export const UNIT_MAP = {
  Temperature: '°F',
  Height: 'in',
  Weight: 'lbs',
  Pulse: 'bpm',
  Protein: '',
  Cholesterol: 'mg/dL',
  Hemoglobin: 'g/dL',
}

export const Y_AXIS_LABEL_MAP = {
  Temperature: '°F',
  Height: 'in',
  Weight: 'lbs',
  Pulse: 'bpm',
  Cholesterol: 'mg/dL',
  Hemoglobin: 'g/dL',
}
